module.exports = __webpack_public_path__ + "static/media/S_J.c1f0e0c8.png";